// extracted by mini-css-extract-plugin
export default {"control":"control_control__iKu81","addIcon":"control_addIcon__02vJd"};